import axios from "axios";

export default function getAllBonanzaPoint({
    length,
    start,
    column,
    order,
    search,
    product,
}) {
    return new Promise((resolve, reject) => {
        axios.get("/campaign/api/admin/campaigns-setting",
            {
                params: {
                    limit: length,
                    skip: start,
                    sortBy: column,
                    order: order,
                    search: search,
                    product: product,
                }
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}
